import ACR from './acr.webp'
import ARTTREES from './art-trees.webp'
import BCR from './bcr.webp'
import CAR from './car.webp'
import CDM from './cdm.webp'
import CERCARBONO from './cer-carbono.webp'
import GCC from './gcc.webp'
import GOLD from './gold.webp'
import ICR from './icr.webp'
import IREC from './irec.webp'
import LCL from './lcl.webp'
import MITECO from './miteco.webp'
import PLANVIVO from './plan-vivo.webp'
import PURO from './puro.webp'
import UKWOODLAND from './uk-woodland-carbon-code.webp'
import VCS from './vcs.webp'

export const LOGO_STANDARD_IMAGES = {
  ACR,
  ARTTREES,
  BCR,
  CAR,
  CDM,
  CERCARBONO,
  GCC,
  GOLD,
  ICR,
  IREC,
  LCL,
  MITECO,
  PLANVIVO,
  PURO,
  UKWOODLAND,
  VCS
}
